import { render, staticRenderFns } from "./RecurringLimit.vue?vue&type=template&id=172537cc&scoped=true"
import script from "./RecurringLimit.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecurringLimit.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RecurringLimit.vue?vue&type=style&index=0&id=172537cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172537cc",
  null
  
)

export default component.exports